import { Box } from "@mui/material";

const ProductImage = ({
  margin,
  card,
  maxWidth,
  maxHeight,
  width,
  padding,
  height,
  imageLink,
}: any) => {
  const imageSrc = imageLink || card.main_image || card.image;

  return (
    <Box sx={{ marginBottom: { xs: 0.75, sm: 0 } }}>
      <Box
        component="img"
        sx={{
          margin: margin ?? 0,
          width: width ?? "auto",
          height: height ?? "auto",
          maxWidth: maxWidth ?? "100%",
          maxHeight: maxHeight ?? "100%",
          padding: padding ?? 0,
          objectFit: "contain",
          display: "block",
          borderRadius: "5px",
        }}
        src={imageSrc}
        alt={card?.title || "Product Image"}
        loading="lazy"
      />
    </Box>
  );
};

export default ProductImage;
